
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/shiva/topic/[topic]",
      function () {
        return require("private-next-pages/mahashivratri/shiva/topic/[topic]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/shiva/topic/[topic]"])
      });
    }
  